import React, { ButtonHTMLAttributes } from "react";
import { MdDelete, MdEdit } from "react-icons/md";
import { AiFillEye } from "react-icons/ai";

type BtnPropsType = {
	label: string;
	width?: string;
	isLoading?: boolean;
};

export function Button({
	isLoading = false,
	label,
	width,
	...rest
}: BtnPropsType & ButtonHTMLAttributes<HTMLButtonElement>) {
	return (
		<React.Fragment>
			{!isLoading ? (
				<button
					className={`btn bg-orange-500 text-white text-sm font-semibold ${width}`}
					{...rest}
				>
					{label}
				</button>
			) : (
				<button
					className={`btn bg-orange-500 text-white text-sm font-semibold ${width}`}
					disabled={true}
					{...rest}
				>
					<span>en_cours &nbsp;</span>
				</button>
			)}
		</React.Fragment>
	);
}
export const ButtonView: React.FC<ButtonHTMLAttributes<HTMLButtonElement>> = ({ ...rest }) => {
	return (
		<button
			title="Voir"
			className="text-sm text-red-600 hover:bg-red-100 p-1 rounded-full"
			type="button"
			{...rest}
		>
			<AiFillEye />
		</button>
	);
};
export const ButtonEdit: React.FC<ButtonHTMLAttributes<HTMLButtonElement>> = ({ ...rest }) => {
	return (
		<button
			title="Modifier"
			className="text-base text-teal-500 hover:bg-teal-100 p-1 rounded-full"
			type="button"
			{...rest}
		>
			<MdEdit />
		</button>
	);
};

export const ButtonDelete: React.FC<ButtonHTMLAttributes<HTMLButtonElement>> = ({ ...rest }) => {
	return (
		<button
			title="Supprimer"
			className="text-sm text-red-600 hover:bg-red-100 p-1 rounded-full"
			type="button"
			{...rest}
		>
			<MdDelete />
		</button>
	);
};

export const CloseModalButton = ({
	text,
	...rest
}: { text?: string } & ButtonHTMLAttributes<HTMLButtonElement>) => {
	return (
		<>
			{text ? (
				<button
					type="button"
					className="text-red-500 background-transparent font-semibold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
					{...rest}
				>
					{text}
				</button>
			) : (
				<button
					className="text-red-500 background-transparent font-semibold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
					type="button"
					{...rest}
				>
					x
				</button>
			)}
		</>
	);
};
